<template>
  <div class="row pos-table-row">
    <div class="col-9">
      <div class="pos-product-thumb">
        <div class="img ts-text-center">
          <img
            class="img"
            v-lazy="{
              src: getProduct(order.product_id).photo
                ? getProduct(order.product_id).photo
                : require('@/assets/default-product.jpg'),
              error: require('@/assets/default-product.jpg'),
              loading: require('@/assets/Rolling-1s-200px_2.svg')
            }"
          />
          <span class="text-info ts-font-bold">
            {{
              getProduct(order.product_id)
                ? getProduct(order.product_id).barcode
                : ''
            }}
          </span>
        </div>
        <div class="info">
          <div class="title">
            {{
              getProduct(order.product_id)
                ? getProduct(order.product_id).product_name_kh
                  ? getProduct(order.product_id).product_name_kh
                  : getProduct(order.product_id).product_name_en
                : ''
            }}
            <small>{{ order.remarks ? '(' + order.remarks + ')' : '' }}</small>
          </div>
          <div class="single-price">
            <span class="ts-text-blue-600"
              >{{ defaultCrrency }} {{ order.unit_price }}</span
            >
            - {{ $t('restaurantSale.size') }}:
            {{ getUomName(order.product_id, order.uom_id) }}
          </div>
          <div class="desc">
            - {{ $t('restaurantSale.discount') }}
            {{ order.discount_rate ? '(' + order.discount_rate + order.discount_type + ')' : '' }}:
            <span class="text-warning"
              >{{ defaultCrrency }} {{ order.discount_amount }}</span
            >
          </div>
          <div class="ts-flex ts-items-center">
            <div class="input-group qty">
              <div class="input-group-append">
                <a
                  href="#"
                  class="btn btn-default"
                  @click.prevent="
                    ;[
                      $emit('set-promotion-item-free-item', {
                        product_id: order.product_id,
                        uom_id: order.uom_id,
                        unit_price: order.unit_price,
                        quantity: order.quantity-- - 1
                      }),
                      $emit('set-promotion-discount-ordered', order)
                    ]
                  "
                  :disabled="
                    order.quantity <= 1 ||
                      order.is_pre_charge ||
                      isAllowAdjustFreeQuantity(order)
                  "
                  ><i class="fa fa-minus"></i
                ></a>
              </div>
              <input
                type="text"
                class="form-control"
                v-model.number="order.quantity"
                @input="
                  ;[
                    $emit('set-promotion-item-free-item', {
                      product_id: order.product_id,
                      uom_id: order.uom_id,
                      unit_price: order.unit_price,
                      quantity: order.quantity
                    }),
                    $emit('set-promotion-discount-ordered', order)
                  ]
                "
                @focus="$event.target.select()"
                :class="{
                  'is-invalid': safeErrors.has(
                    'products.' + index + '.quantity'
                  )
                }"
                :disabled="
                  order.is_pre_charge || isAllowAdjustFreeQuantity(order)
                "
              />
              <div class="input-group-prepend">
                <a
                  href="#"
                  class="btn btn-default"
                  @click.prevent="
                    ;[
                      $emit('set-promotion-item-free-item', {
                        product_id: order.product_id,
                        uom_id: order.uom_id,
                        unit_price: order.unit_price,
                        quantity: order.quantity++ + 1
                      }),
                      $emit('set-promotion-discount-ordered', order)
                    ]
                  "
                  :disabled="
                    order.is_pre_charge || isAllowAdjustFreeQuantity(order)
                  "
                  ><i class="fa fa-plus"></i
                ></a>
              </div>
            </div>
            <div>
              <input
                v-model="order.discount_rate"
                type="number"
                @focus="$event.target.select()"
                placeholder="discount"
                class="ts-w-12 ts-font-semibold ts-mt-2 ts-ml-3 ts-px-1 ts-py-1 ts-rounded-sm ts-border ts-outline-none ts-border-gray-400 ts-text-center"
                disabled
              />
              <span class="ts-font-semibold ts-ml-1">{{ order.discount_type }}</span>
            </div>
          </div>
          <div
            class="validate"
            v-if="safeErrors.has('products.' + index + '.quantity')"
          >
            {{ safeErrors.first('products.' + index + '.quantity') }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-3 total-price text-success">
      <div v-if="order.is_pre_charge && order.stock_out_id != null">
        {{ defaultCrrency }}
        {{ order.total_after_discount | format_number }}
        <br />
        <span class="text-success">Paid</span>
      </div>
      <div v-else>
        {{ defaultCrrency }} {{ order.grand_total }}
        <br />
        <br />
        <small
          v-if="order.cooking_status_id == 2 || order.cooking_status_id == 2"
          class="desc"
          :class="cookingStatus(order.cooking_status_id)"
          ><i class="fas fa-mortar-pestle"></i>
          {{ order.cooking_status }}</small
        >
        <a
          href="#"
          class="btn btn-danger btn-xs"
          v-if="!order.promo_type_id || order.promo_type_id == 1"
          @click.prevent="
            () => [
              (product_id_delete = order.product_id),
              (uom_id_delete = order.uom_id),
              (quantity_delete = order.quantity),
              (unit_price_delete = order.unit_price)
            ]
          "
        >
          <i class="fa fa-trash"></i>
        </a>
      </div>
    </div>
    <div
      class="pos-remove-confirmation"
      v-if="
        product_id_delete == order.product_id &&
          uom_id_delete == order.uom_id &&
          quantity_delete == order.quantity &&
          unit_price_delete == order.unit_price
      "
    >
      <svg
        width="2em"
        height="2em"
        viewBox="0 0 16 16"
        class="mr-2"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
        />
        <path
          fill-rule="evenodd"
          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
        />
      </svg>
      {{ $t('are_you_sure_to_delete') }}
      <a
        href="#"
        class="btn btn-white ml-auto mr-2"
        @click.prevent="
          () => [
            (product_id_delete = null),
            (uom_id_delete = null),
            (quantity_delete = null),
            (unit_price_delete = null)
          ]
        "
        >{{ $t('no') }}</a
      >
      <a
        href="#"
        class="btn btn-danger"
        @click.prevent="$emit('remove-item', order)"
        >{{ $t('yes') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderItem',
  props: {
    order: Object,
    index: Number,
    errors: {
      // ADD PROP DEFINITION
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      product_id_delete: null,
      uom_id_delete: null,
      quantity_delete: null,
      unit_price_delete: null
    }
  },
  computed: {
    ...mapGetters('restaurantSale/customerOrder', ['getProduct', 'getUomName']),
    defaultCrrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        ? this.$store.state.restaurantSale.customerOrder.systemSettings
            .default_currency
        : ''
    },
    safeErrors() {
      // ADD COMPUTED PROPERTY FOR SAFE ERRORS ACCESS
      return this.errors || { has: () => false, first: () => '' }
    }
  },
  methods: {
    cookingStatus(cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    isAllowAdjustFreeQuantity(order) {
      if (
        (order.promo_type_id == 2 || order.promo_type_id == 4) &&
        !order.is_allow_adjust_free_quantity
      ) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.pos-product-thumb .img {
  object-fit: cover;
  width: 100%;
}
</style>
